<template>
  <div
    class="con-vs-card"
    :class="{ withHover: actionable, fixedHeight }"
  >
    <header v-if="$slots.header" class="vs-card--header">
      <slot name="header" />
    </header>
    <div v-if="$slots.media" class="vs-card--media">
      <slot name="media" />
    </div>
    <div
      v-if="$slots.default"
      class="vs-card--content"
      :class="{ fixedHeight }"
    >
      <slot />
    </div>
    <div v-if="$slots['extra-content']" class="vs-card-extra--content">
      <slot name="extra-content" />
    </div>
    <footer
      v-if="$slots.footer"
      class="vs-card--footer"
      :class="{ fixedHeight }"
    >
      <slot name="footer" />
    </footer>
  </div>
</template>

<script>
export default {
  name: "VsCard",
  props: {
    actionable: {
      type: Boolean,
      default: false,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
